var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1a.5.5 0 0 0-.5.5v18a.5.5 0 0 0 .5.5h18a.5.5 0 0 0 .5-.5v-18a.5.5 0 0 0-.5-.5h-18zm18 20h-18C.673 21 0 20.327 0 19.5v-18C0 .673.673 0 1.5 0h18c.827 0 1.5.673 1.5 1.5v18c0 .827-.673 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24h-18c-.827 0-1.5-.673-1.5-1.5a.5.5 0 0 1 1 0 .5.5 0 0 0 .5.5h18a.5.5 0 0 0 .5-.5v-18a.5.5 0 0 0-.5-.5.5.5 0 0 1 0-1c.827 0 1.5.673 1.5 1.5v18c0 .827-.673 1.5-1.5 1.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardView);
export default __webpack_public_path__ + "static/media/card-view.6c64c48eafaf5327746992a713ff4f5f.svg";
export { ForwardRef as ReactComponent };